<template>
    <b-modal id="send-invite-modal" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
        :body-class="'equipment-edit-modal'" no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ displayTitle }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="body">
            <b-row>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('sendInviteModal.passwordLabel')" class="text-left mb-0 password show-password-section">
                        <b-form-input v-model="password" :placeholder="$t('sendInviteModal.passwordPlaceholder')" class="unit"
                            :type="showPassword ? 'text' : 'password'" required></b-form-input>

                        <b-icon :icon="showPassword ? 'eye-fill' : 'eye-slash-fill'"
                            @click="showPassword = !showPassword"></b-icon>
                        <p v-if="errors && errors.password" class="field-error mb-lg-3">
                            {{ errors.password[0] }}
                        </p>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="resetForm()" variant="secondary">{{ $t('sendInviteModal.cancel') }}</b-button>
                <div class="d-flex align-items m-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendInvite()">{{ $t('sendInviteModal.invite') }}</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
export default {
    name: "SendInvite",
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    computed: {
        displayTitle() {
            return this.title || this.$t('sendInviteModal.defaultTitle');
        }
    },
    data() {
        return {
            showPassword: false,
            password: "",
            errors: {

            }
        }
    },
    methods: {
        resetForm() {
            this.password = "",
                this.errors = {
                }
            this.$bvModal.hide('send-invite-modal')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        sendInvite() {
            try {
                const nullKeys = this.checkNullValues({
                    password: this.password
                })
                if (nullKeys.length === 0) {
                    this.$emit("sendInvite", this.password)
                    this.password = "",
                    this.errors = {};
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('sendInviteModal.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        }
    },
}
</script>